import React, {useMemo, useState, useEffect} from "react";
// import './GeneralSetting.scss'
import styles from './GeneralSetting.module.scss'
import Radio from "@components/Radio";
import Dropdown from "@components/Dropdown";
import Switch from "@components/Switch";
import Input from "@components/Input";
import Button from "@components/Button";
import { FontType, RenderingQualityKeyType, SETTING_CONTENTS_NAMES, ThemeType } from "config/settingsConfig";
import { GeneralSetting, updateGeneralSetting } from "@features/analysis/analysisModal/SettingsModal/SettingsModalSlice";
import { useSettingsModal } from "@features/analysis/analysisModal/SettingsModal/useSettingsModal";
// import { setGPUAcceleration } from "@features/analysis/rendering/Panels/Renderers/CornerstoneManager";
import useGetStorage from "@hooks/Utilities/useUtilities";
import { useConfig } from "config/useConfig";

// import { useSettings } from "@hooks/useSetting";

// CSS 수정
// 변경 시 dispatch로 상태 변경 알림
// Input 값 설정
function GeneralSetting() :React.JSX.Element {
  const { data } = useGetStorage();
  const {general,
    setGeneralSetting,handleTheme
    ,handleFont
    ,handleCacheLimit
    ,handleAutomaticallyClearCacheFlag
    ,handleIntervalDay
    // ,handleGPUAccelerationFlag
    ,handleStorageAlertNotificationFlag
    ,handleRenderingQualityType
    // ,handleEnableProxyServerFlag
    // ,handleProxyIP
    // ,handleProxyPort
  } = useSettingsModal();
  const {config} = useConfig();

  const restartRequired = config.generalSetting.renderingQuality !== general.renderingQuality;

  return (
    <div className={styles.container}>
      <div className={styles.group}>
        <div className={styles.groupTitle}>
          <span className={styles.groupHeader}> {SETTING_CONTENTS_NAMES.general.environment}</span>
          <div className={styles.groupDivider}/>
        </div>
        <div className={styles.block}>
          <div className={styles.radioGroup}>
            <span className={styles.label}> {SETTING_CONTENTS_NAMES.general.theme} </span>
            <div className={styles.content}>
              <div className={styles.options}>
              {Object.entries(SETTING_CONTENTS_NAMES.general.themes).map(([key, value]) => (
              // {["Light Mode", "Dark Mode"].map((mode, index) => (
                  <div key={key} className={styles.radio}>
                    <div className={styles.radioContainer}
                      onClick={()=>handleTheme(value as ThemeType)}
                    >
                      <span className={styles.radioButton}>
                        <Radio
                          onChange={()=>handleTheme(value as ThemeType)}
                          value={value}
                          checked={general.theme === value}
                        />
                      </span>
                      <span className={styles.radioText}>{value}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={styles.Frame1000008018}>
            <div className={styles.select}>
              <span className={styles.label}> {SETTING_CONTENTS_NAMES.general.font} </span>

              <Dropdown
                placeholder="Font"
                options={Object.entries(SETTING_CONTENTS_NAMES.general.fonts).map(([key,value])=>{
                  return{
                    value:value,
                    label:value
                  };
                })}
                value={general.font}
                onChange={(value)=>handleFont(value as FontType)}
                className="font-dropdown"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.group}>
        <div className={styles.groupTitle}>
          <span className={styles.groupHeader}> {SETTING_CONTENTS_NAMES.general.storage}</span>
          <div className={styles.groupDivider}/>
        </div>
        <div className={styles.block2}>
          <div className={styles.block2Row}>
            <span className={styles.label}>{SETTING_CONTENTS_NAMES.general.cacheManagement}</span>
          </div>
          <div className={styles.Frame1000008006}>
            <div className={styles.numberInput1}>
              <span className={styles.niLabel1}> {SETTING_CONTENTS_NAMES.general.cacheLimit} </span>
              <Input
                placeholder="Number Input"
                type="number"
                value={general.cacheLimit}
                className="setting-storage-input"
                onChange={(e) => {
                  const newValue = e.target.value;
                  if (newValue === '' || /^\d*$/.test(newValue)) { // 숫자만 입력 가능하도록 정규식 검사
                    handleCacheLimit(Number(newValue))
                  }
                }}
                disabled={true}// 우리꺼 지금 매일매일 자동사냥
              />
            </div>
            <div className={styles.numberInput2}>
              <span className={styles.niLabel2}> {SETTING_CONTENTS_NAMES.general.automaticallyClearCache} </span>

              <Switch
                id="test-switch"
                checked={general.automaticallyClearCache}
                onChange={(e)=>handleAutomaticallyClearCacheFlag(e)}
                disabled={true}// 우리꺼 지금 매일매일 자동사냥
              />
            </div>
            <div className={styles.numberInput1}>
              <span className={styles.niLabel1}> {SETTING_CONTENTS_NAMES.general.intervalDay} </span>
              <Input
                placeholder="Number Input"
                type="number"
                value={general.intervalDay}
                className="setting-storage-input"
                onChange={(e) => {
                  const newValue = e.target.value;
                  if (newValue === '' || /^\d*$/.test(newValue)) { // 숫자만 입력 가능하도록 정규식 검사
                    handleIntervalDay(Number(newValue))
                  }
                }}
                disabled={true}// 우리꺼 지금 매일매일 자동사냥
              />
            </div>
            <div className={styles.numberInput4}>
              <Button
                className="action-control clear"
              >
                {SETTING_CONTENTS_NAMES.general.clearCache}
              </Button>
            </div>
            <div/>
          </div>
        </div>

        <div className={styles.block2}>
          <div className={styles.block2Row}>
            <span className={styles.label}>{SETTING_CONTENTS_NAMES.general.monitoring}</span>
          </div>
          <div className={styles.Frame1000008006}>
            <div className={styles.numberInput5}>
              <span className={styles.niLabel5}>{`${SETTING_CONTENTS_NAMES.general.usageStorage} : `}</span>
              <span className={styles.niLabel5Button}>{`${data?.chargedPercentage}% used (${(Number(data?.storageSize) - Number(data?.freeSpace)).toFixed(2)} GB / ${data?.storageSize} GB)`}</span>
            </div>
            <div className={styles.numberInput6}>
              <span className={styles.niLabel5}>{`${SETTING_CONTENTS_NAMES.general.freeStorage} : `}</span>
              <span className={styles.niLabel5Button}>{`${data?.freeSpace} GB free`}</span>
            </div>
            <div className={styles.numberInput2}>
              <span className={styles.niLabel2}> {SETTING_CONTENTS_NAMES.general.storageAlertNotification} </span>
              <Switch
                id="storage-alert-notification-switch"
                checked={general.storageAlertNotification !== false}
                onChange={(checked)=>handleStorageAlertNotificationFlag(checked)}
              />
            </div>
          </div>
        </div>
      </div>


      <div className={styles.group}>
        <div className={styles.groupTitle}>
          <span className={styles.groupHeader}> {SETTING_CONTENTS_NAMES.general.system}</span>
          <div className={styles.groupDivider}/>
        </div>
        <div className={styles.block}>
          {/* <div className="general-container-sys-section-switch">
            <div className="general-container-sys-section-switch-title">
            {SETTING_CONTENTS_NAMES.general.GPUAcceleration}
            </div>
            <Switch
              id="test-switch"
              checked={general.GPUAcceleration}
              onChange={(e)=>handleGPUAccelerationFlag(e)}
            />
          </div> */}
          <div className={styles.radioGroup}>
            <span className={styles.label}> {SETTING_CONTENTS_NAMES.general.renderingQuality} </span>
            <div className={styles.content}>
              <div className={styles.options}>
              {
                ['high', 'medium', 'low'].map((mode, index) =>
                  // <div key={mode} className="general-container-env-section-theme-radio-1">
                  <div key={mode} className={styles.radio}>
                    <div className={styles.radioContainer}>
                      <Radio
                        onChange={()=>
                          // setRenderingQuality(mode as RenderingQualityKeyType)
                          handleRenderingQualityType(mode as RenderingQualityKeyType)
                        }
                        value={SETTING_CONTENTS_NAMES.general.renderingQualities[mode as RenderingQualityKeyType]}
                        checked={general.renderingQuality === mode}
                      />
                      <span className={styles.radioText}> {SETTING_CONTENTS_NAMES.general.renderingQualities[mode as RenderingQualityKeyType]} </span>
                    </div>
                  </div>
                )
              }
              { restartRequired &&
                <div className="general-container-sto-section1-section2-waring">{`Restart required`}</div>
              }
              </div>
            </div>
          </div>
          {/* <div className="general-container-sys-section-proxy">
            <div className="general-container-sys-section-proxy-title">
            {SETTING_CONTENTS_NAMES.general.proxySetting}
            </div>
            <div className="general-container-sys-section-proxy-section2">
              <div className="general-container-sys-section-switch">
                <div className="general-container-sys-section-switch-title">
                {SETTING_CONTENTS_NAMES.general.enableProxyServer}
                </div>
                <Switch
                  id="test-switch"
                  checked={general.enableProxyServer}
                  onChange={(e)=>handleEnableProxyServerFlag(e)}
                />
              </div>
              <div className="general-container-sys-section-proxy-section2-ip">
                <div className="general-container-sys-section-proxy-section2-ip-title">
                {SETTING_CONTENTS_NAMES.general.proxyIPaddress}
                </div>
                <Input
                  placeholder="Input"
                  type="number"
                  value={general.proxyIP}
                  className="input-size2"
                  onChange={(e) => handleProxyIP(e.target.value)}
                />
                <div className="general-container-sys-section-proxy-section2-ip-title">
                {SETTING_CONTENTS_NAMES.general.proxyPort}
                </div>
                <Input
                  placeholder="Input"
                  type="number"
                  value={general.proxyPort}
                  className="input-size"
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue === "" || /^\d*$/.test(newValue)) {
                      handleProxyPort(newValue)
                    }
                  }}
                />
              </div>
              <div className="general-container-sys-section-proxy-section2-ip">
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default GeneralSetting;
